module.exports = __webpack_public_path__ + "img/blogpost1.749e1a5c.jpg";